"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _TVChartComponent = _interopRequireDefault(require("./TVChartComponent"));
var _tickersActions = require("../../redux/actions/tickersActions");
var _futuresTickersActions = require("../../redux/futures/actions/futuresTickersActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../redux/futures/selectors");
var _fms = require("../../services/fms/fms");
var _wsHelper = require("../../helpers/wsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var isFuturesActive = (0, _selectors.isFuturesActiveSelector)(state);
  var selectedInstrument = isFuturesActive ? (0, _selectors.futuresSelectedInstrumentSelector)(state) : (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  return {
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    gateway: isFuturesActive ? (0, _fms.getFMSGateway)() : (0, _wsHelper.getGateway)(),
    selectedInterval: state.tickers.interval,
    isFuturesActive: isFuturesActive
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    changeTickersInterval: function changeTickersInterval() {
      if (ownProps.isFuturesActive) {
        // Only dispatch changeFuturesTickersInterval if futures is enabled in props
        dispatch((0, _futuresTickersActions.changeFuturesTickersInterval)());
      } else {
        // Handle the case when futures is not enabled (optional)
        dispatch((0, _tickersActions.changeTickersInterval)());
      }
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TVChartComponent["default"]);